module.exports = __webpack_public_path__ + "img/footer_title.52ab5f80.png";